import angular from 'angular';

import _css from './od-listing-card-mini.less';

module.exports = angular.module('market.components.od-listing-card-mini', [])
.component('odListingCardMini', {
  bindings: {
    listing: '<',
  },
  template: require('./od-listing-card-mini.jade')(),
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-listing-card-mini.js
 **/